.fdi.wc.multiselect{
  position: relative;
  padding: 0 !important;
  margin: 0 !important;
  .menu{
    width: 100%;
    padding: 5px;
    div{
      margin-right: 5px;
      display: inline-block;
      padding: 2px;
      cursor: pointer;
      color: #4e4e4e;
      font-size: 15px;
      &:hover{
        text-decoration: underline;
      }
    }
  }
  #optionsContainer{
    position: absolute;
    background: white;
    outline: solid 1px #ccc;
    overflow-y: auto;
    .option{
      padding: 0 5px;
      span{
        width: 100%;
        height: 100%;
      }
      &:hover{
        background: #f3f3f3;
        cursor: pointer;
      }
      &.selected{
        background: #cccccc;
        color: #ececec;
      }
    }
  }
  #selectedContainer{
    padding: 5px;
    display: flex;
    .removeSelected{
      float: left;
      margin: 0 5px;
      &:hover{
        cursor: pointer;
      }
    }
    .selectedContent{
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .selected.list-mode{
      padding: 1px 5px;
    }
    .selected.tag-mode{
      max-width: 40%;
      display: inline-flex;
      border: solid 1px;
      border-color: #c78203;
      border-radius: 5px;
      margin: 5px 5px 0 0;
      padding: 2px;
      background: orange;
      color: white;
    }
  }
}
